import React from 'react';
import classes from './HrpPage.module.css';
import { BasicContainer } from '../../UI/ContentContainer';

import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Typography, Box, Card, Container, CardContent, Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import NumberList from '../../UI/NumberList';
import SandGlass from '../../../assets/img/sandGlass.png';
import SmoFoldList from '../SmoPage/SmoFoldList';
import Payment from '../../common/Payment';

import calendar from '../../../assets/img/calendar.png';
import Calendar from '../ImageComponent/Calendar';
import MetaTags from '../../MetaTags/MetaTags';


const item = [
    '금속가공제품(기계 및 가구는 제외한다) 제조업',
    '비금속 광물제품 제조업',
    '기타 기계 및 장비 제조업',
    '자동차 및 트레일러 제조업',
    '식료품 제조업',
    '고무제품 및 플라스틱제품 제조업',
    '목재 및 나무제품 제조업',
    '기타 제품 제조업',
    '1차 금속 제조업',
    '가구 제조업',
    '화학물질 및 화학제품 제조업',
    '반도체 제조업',
    '전자부품 제조업'
];

const targetItem = [
    '금속이나 그 밖의 광물의 용해로(용량 3톤 이상)',
    '화학설비',
    '건조설비(연료의 최대소비량 50kg/hr 이상 또는 최대소비전력 50kw 이상)',
    '가스집합 용접장치(인화성가스 집합량 1,000kg 이상)',
    '제조등금지물질 또는 허가대상물질 관련 설비',
    '분진작업 관련 설비'
]


const TABLE_DATA = [
    {
        id: 1,
        title: 
            <div className={classes.foldList}>
                <p>법 제42조제1항을 위반하여 유해위험방지 계획서 또는 자체 심사결과서를 작성하여 제출하지 않은 경우</p>
                <p>1. 대통령령으로 정하는 사업의 종류 및 규모에 해당하는 사업</p>
                <p>2. 대통령령으로 정하는 기계·기구 및 설비 에 해당하는 사업</p>
            </div>,
        subtitle: '제재사항',
        tableHead: ['근거법조문', '1차', '2차', '3차'],
        data: [
            [
                '법 제175조 제4항 제3호', 1000, 1000, 1000
            ],
        ]
    }


]




const HrpPage = () => {

    return (
        <BasicContainer>
            <MetaTags
                title="유해위험방지계획서"
                description="유해위험방지계획서에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-유해위험방지계획서"
                ogdescription="유해위험방지계획서에 대해 소개 합니다."
            />
            <PageTitle title="유해위험방지계획서"/>
            <TextContent title="유해위험방지계획서 작성 컨설팅">
                <Typography variant="description" component="p" sx={{lineHeight: "2"}} data-aos="fade-up">
                    대통령령으로 정하는 사업의 종류 및 규모에 해당하는 사업으로서 해당 제품의 생산 공정과 직접적으로 관련된 건설물·기계·기구 및 설비 등 일체를 설치·이전하거나 그 주요 구조부분을 변경하는 경우 또는 유해하거나 위험한 작업 또는 장소에서 사용하거나 건강장해를 방지하기 위하여 사용하는 기계·기구 및 설비로서 대통령령으로 정하는 기계·기구 및 설비를 설치·이전하거나 그 주요 구조부분을 변경하는 경우에는 유해·위험방지계획서를 작성하여 고용노동부장관에게 제출토록 하고 있음.
                </Typography>
            </TextContent>

            <TextContent title="제출 대상 사업장" data-aos="fade-up">
                <Typography variant="description" component="p" sx={{lineHeight: "2"}}>
                제품생산 공정과 직접적으로 관련된 건설물·기계·기구 및 설비 등 일체를 설치·이전하거나 그 주요 구조부분을 변경하는 경우
                </Typography>
                <Box marginTop="2rem">
                    <table className={classes.table}>
                        <caption>
                            <Typography variant="contentTitleSmall" component="p" textAlign="left">대상업종 : 전기계약용량 300kw 이상</Typography>
                        </caption>
                        <thead>
                            <tr>
                                <th><Typography variant="contentTitleSmall" component="p">NO</Typography></th>
                                <th><Typography variant="contentTitleSmall" component="p">대상업종</Typography></th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.map((item, index) => (
                                <tr key={index}>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="center">{index+1}</Typography></td>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="left">{item}</Typography></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
                <Box marginTop="2rem">
                    <table className={classes.table}>
                        <caption>
                            <Typography variant="contentTitleSmall" component="p" textAlign="left">대상설비 : 모든 업종</Typography>
                        </caption>
                        <thead>
                            <tr>
                                <th><Typography variant="contentTitleSmall" component="p">NO</Typography></th>
                                <th><Typography variant="contentTitleSmall" component="p">대상설비</Typography></th>
                            </tr>
                        </thead>
                        <tbody>
                            {targetItem.map((item, index) => (
                                <tr key={index}>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="center">{index+1}</Typography></td>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="left">{item}</Typography></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
                
            </TextContent>


            <TextContent maxWidth="lg" data-aos="fade-up">
                <Grid container spacing={2} alignItems="strech">
                    <Grid xs={12} sm={5} md={3} className={classes.imageBackground}>
                        <div className={classes.imageArea}>
                            <Calendar style={{width: '10rem'}}/>
                            {/* <img src={calendar} alt="calendar.png" className={classes.contentImage}/> */}
                        </div>
                    </Grid>
                    <Grid xs={12} sm={7} md={9}>
                        <Box >
                            <Typography variant="subTitle" component="h2">제출시기</Typography>
                            <Typography variant="description" component="p" sx={{lineHeight: "2", marginBottom: '10px'}} >
                                해당 작업 시작 15일 전까지 유해·위험 방지계획서 2부를 작성하여 공단에 제출
                            </Typography>
                            <Divider sx={{margin: '20px 0'}}/>
                            <Box>
                                <Typography variant="contentTitle" component="h2">작업시작 전이란? </Typography>
                                <Typography variant="reference" component="p">건설물·기계·기구 및 설비 등 설치·이전·변경을 시작하는 시점으로 주요 설비 설치공사 시작 시점을 의미함</Typography>
                                <Typography variant="reference" component="p">- 「건설물」에 해당하는 경우 : “착공 전”</Typography>
                                <Typography variant="reference" component="p">- 「기계·기구 및 설비」에 해당하는 경우 : “해당 기계·기구 및 설비 설치 전”</Typography>
                                <Typography variant="reference" component="p">※ “착공” 이란 유해·위험방지계획서 작성 대상 시설물 또는 구조물의 공사를 시작하는 것을 말함</Typography>
                            </Box>
                        </Box>

                    </Grid>
                </Grid>
            </TextContent>

            <TextContent title="법적제재사항" data-aos="fade-up">
                <Typography variant="h6">위반행위</Typography>
                <div style={{display: "flex", flexDirection:"column", gap: "10px"}}>
                {
                    TABLE_DATA.map(data => (
                        <SmoFoldList 
                            key={data.id}
                            titleSx={{whiteSpace: 'pre-line'}}
                            title={data.title}
                            subtitle={data.subtitle}
                            thead={data.tableHead}
                            data={data.data}
                        />
                    ))
                }

                </div>
            </TextContent>

            {/* <TextContent title="용역대가" maxWidth="lg">
                <Payment>
                    <Typography variant="description" component="p" textAlign="center" sx={{lineHeight: "2"}}>
                        엔지니어링산업 진흥법 제31조 제2항의 규정에 따라 전기 계약용량 및 업종, 기계·기구 설비 종류를 고려하여 견적금액을 산출함
                    </Typography>
                </Payment>
            </TextContent> */}
            
        </BasicContainer>
    )
}

export default HrpPage;